import HeaderFooterLayout from '../js/layout/HeaderFooterLayout';
import type { StaticLayoutProps } from '../js/layout/Layout';
import ProductGuide from '../js/productGuide';

export default function () {
    return <ProductGuide />;
}

export function StaticLayout({ url }: StaticLayoutProps<null>) {
    const canonical = new URL(url);
    canonical.search = '';
    return <HeaderFooterLayout title="Drikkevelger" page_title="Drikkevelger" robots="nofollow" canonical={canonical.toString()} />;
}
